import { Injectable } from '@angular/core';
import { CoreException, Response } from '@sdk/sdk';
import { McpClientRequest } from '../../auth';
import { McpRequestsRepository } from '../repositories/mcp-requests.repository';

/** Asks the Sytex MCP server what an MCP login's sealed state stands for. */
@Injectable({ providedIn: 'root' })
export class GetMcpClientRequestUseCase {
  constructor(private _repository: McpRequestsRepository) {}

  execute(serverOrigin: string, state: string): Promise<Response<McpClientRequest, CoreException>> {
    return this._repository.get(serverOrigin, state);
  }
}
